import { message } from "antd";
import Service from "../service";

const XLSX_MIME =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

/**
 * Fetch a company-specific "Sample CSV" import template from the backend and
 * trigger a browser download.
 *
 * Every Sample CSV button uses this so the downloaded file is pre-filled with
 * the company's REAL employee codes and names (scoped server-side by companyId)
 * instead of hardcoded placeholder rows. The backend responds with
 * `{ status: 200, data: <base64>, filename, mime }`.
 *
 * @param {string} apiUrl relative template endpoint (e.g. Service.leaveBalanceTemplate)
 * @param {Object} [opts]
 * @param {string} [opts.fallbackName="sample.xlsx"] filename if backend omits one
 * @returns {Promise<boolean>} true when the download was triggered
 */
export const downloadImportTemplate = async (
  apiUrl,
  { fallbackName = "sample.xlsx" } = {}
) => {
  try {
    const response = await Service.makeAPICall({
      methodName: Service.getMethod,
      api_url: apiUrl,
    });

    if (response?.data?.status === 200 && response?.data?.data) {
      const byteCharacters = atob(response.data.data);
      const byteArray = new Uint8Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteArray[i] = byteCharacters.charCodeAt(i);
      }
      const blob = new Blob([byteArray], {
        type: response.data.mime || XLSX_MIME,
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = response.data.filename || fallbackName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      return true;
    }

    message.error(response?.data?.message || "Failed to download sample CSV");
    return false;
  } catch (error) {
    message.error("Failed to download sample CSV");
    return false;
  }
};

export default downloadImportTemplate;
